import { Box, Tooltip } from '@mui/material';
import { PoolChip, ValueOrNDash } from '@synergy/components';
import { useMemo } from 'react';

import { eclassSelector } from '../../../../../common/selectors/eclass-selectors';
import { useAppSelector } from '../../../../../store/use-appstate-selector';

interface EclassInfo {
    chip: number;
    tooltip: string;
}

export const CategoryConfigurationRowEclass = ({ eclassPositions }: { eclassPositions?: number[] }) => {
    const eclasses = useAppSelector(eclassSelector);

    const infos: EclassInfo[] = useMemo(
        () =>
            eclassPositions?.map(eclassPosition => ({
                chip: eclassPosition,
                tooltip: eclasses.find(eclass => eclass.id === eclassPosition)?.label ?? '',
            })) ?? [],
        [eclassPositions, eclasses]
    );

    return (
        <ValueOrNDash>
            {infos.map(eclass => (
                <Tooltip key={eclass.chip} title={eclass.tooltip} placement="top">
                    <Box sx={{ display: 'inline' }}>
                        <PoolChip label={eclass.chip} type="tag" />
                    </Box>
                </Tooltip>
            ))}
        </ValueOrNDash>
    );
};
